// Environment variables for the application
export const env = {
  // GraphQL API URL - use localhost in development, remote backend in production
  get graphqlUrl() {
    // Use localhost in development mode, remote backend in production
    return import.meta.env.DEV 
      ? 'http://localhost:3000/graphql'
      : (import.meta.env.VITE_GRAPHQL_URL || 'https://backend-system-b7kz.onrender.com/graphql');
  },
  
  // API base URL - follows the same pattern as graphqlUrl
  get apiUrl() {
    return import.meta.env.DEV
      ? 'http://localhost:3000'
      : (import.meta.env.VITE_API_URL || 'https://backend-system-b7kz.onrender.com');
  },
  
  // Environment
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  
  // Application version
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
};